import Auth_API from "./apiConfig";

export const getMyPrograms = async () => {
  try {
    const response = await Auth_API.get("/user/get-my-programs");
    return response.data;
    
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const createNote = async (data) => {
  try {
    const response = await Auth_API.post("/growth/notes", data);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const updateNote = async (noteId, data) => {
  try {
    const response = await Auth_API.put(`/growth/notes/${noteId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
}

export const deleteNote = async (noteId) => {
  try {
    const response = await Auth_API.delete(`/growth/notes/${noteId}`);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
}

export const getMyNotes = async (params) => {
  try {
    const response = await Auth_API.get('/growth/notes',{params});
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);

    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const getMyResources = async () => {
  try{
    const response = await Auth_API.get("/user/get-my-resources")
    return response.data.response.resources
  }catch(error) {
    throw new Error("An unexpected error occurred. Please try again.")
  }
}

/**
 * Get TPStreams playback URL and video progress (merged endpoint)
 * @param {string} tpstreamID - TPStream video ID
 * @returns {Promise<Object>} Response containing playbackUrl, progress, and userData
 */
export const getVideoPlaybackUrl = async (tpstreamID) => {
  try {
    const response = await Auth_API.get(`/growth/video/playback/${tpstreamID}`);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

/**
 * @deprecated Use getVideoPlaybackUrl instead - it now returns both playback URL and progress
 * Get user's video progress for a specific video
 */
export const getVideoProgress = async (tpstreamID) => {
  try {
    const response = await Auth_API.get(`/growth/video/playback/${tpstreamID}`);
    // Return progress from the merged endpoint
    return {
      ...response.data,
      response: {
        progress: response.data?.response?.progress || null,
      },
    };
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const updateVideoStatus = async (data) => {
  try {
    const response = await Auth_API.post("/growth/video/status", data);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

// User-facing analytics APIs
export const getUserVideoAnalytics = async (videoId) => {
  try {
    const response = await Auth_API.get(`/growth/video/analytics/video/${videoId}`);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const getUserCourseProgress = async (programId) => {
  try {
    const response = await Auth_API.get(`/growth/video/analytics/course/${programId}`);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const getUserAllVideosAnalytics = async (programId) => {
  try {
    const response = await Auth_API.get(`/growth/video/analytics/course/${programId}/videos`);
    return response.data;
  } catch (error) {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};